import React from "react";
import clsx from "clsx";

import { ILesson } from "../../../state";
import { prefixPath, projectionPath } from "../../../teacherStore";
import { ReactComponent as ProjectorIcon } from "../../../assets/svg/projector.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/svg/arrow_l.svg";
import { ReactComponent as ArrowRight } from "../../../assets/svg/arrow_r.svg";

import styles from "./GuidelineSidebar.module.scss";

export interface GuidelineSidebarProps {
  lesson: ILesson | null;
  classListString: string;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

export const GuidelineSidebar: React.FC<GuidelineSidebarProps> = ({
  lesson,
  classListString,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  const onShareMaterial = () =>
    lesson &&
    window.open(
      `${prefixPath}${projectionPath}?lesson=${lesson.id}&page=1&classList=${classListString}`,
      "_blank",
    );

  const prevLesson = () => prevLessonId && onChangeLesson(prevLessonId);
  const nextLesson = () => nextLessonId && onChangeLesson(nextLessonId);

  return (
    <div className={styles.container}>
      <ul className={styles.menuList}>
        <li>
          <button
            className={clsx(lesson?.teacher_only && styles.invisible)}
            onClick={onShareMaterial}
          >
            <ProjectorIcon className={styles.projector} />
            投影画面
          </button>
        </li>
        <li>
          <button onClick={prevLesson} disabled={!prevLessonId}>
            <ArrowLeft className={styles.arrow} />
            前の教材
          </button>
          <button onClick={nextLesson} disabled={!nextLessonId}>
            <ArrowRight className={styles.arrow} />
            次の教材
          </button>
        </li>
      </ul>
    </div>
  );
};

export default GuidelineSidebar;
